/**
 * LAS FOTOS QUE EL CLIENTE SUBE EN EL ALTA (13-10): la de su mejor forma y la que pone al
 * lado de los modelos para elegir su porcentaje de grasa.
 *
 * Se guardaban bien y no las veía nadie: el alta las manda a `client_photos` con su marca
 * de `uso` y deja en la ficha solo el id (`foto_mejor_momento_id`, `foto_grasa_id`), y
 * ninguna pantalla leía ese id. No son fotos de progreso, así que tampoco salen (ni deben)
 * en las listas de seguimiento.
 *
 * Aquí se decide, en un solo sitio, QUÉ fotos del alta tiene una ficha y de dónde se pinta
 * cada una:
 *   - `id`: la foto vive en `client_photos` y se pide por la vía de siempre,
 *     `/reports/photos/{id}` (su dueño y el equipo; nadie más).
 *   - `dataUrl`: las fichas de antes del 23-08 llevan la de mejor forma en base64 dentro
 *     del propio perfil. Ya viaja en la ficha, así que se pinta tal cual.
 */
import { num1 } from './numeros';

const FOTOS = [
    { clave: 'mejor_forma', titulo: 'Su mejor forma',
      campoId: 'foto_mejor_momento_id', campoViejo: 'foto_mejor_momento' },
    { clave: 'grasa', titulo: 'La que subió para elegir su % graso',
      campoId: 'foto_grasa_id', campoViejo: 'foto_grasa' },
];

const esImagenEnBase64 = (v) => typeof v === 'string' && v.startsWith('data:image/');

// "74 kg · 2019": el peso y el año que dio con la foto de su mejor forma. Lo que falte, no sale.
const detalleMejorForma = (perfil) => {
    const peso = perfil?.peso_mejor_momento;
    const ano = perfil?.peso_mejor_momento_ano;
    return [
        peso != null && peso !== '' ? `${num1(peso)} kg` : null,
        ano != null && ano !== '' ? String(ano) : null,
    ].filter(Boolean).join(' · ');
};

const detalleGrasa = (perfil) => {
    const g = perfil?.body_fat;
    return g != null && g !== '' ? `Eligió ${num1(g)} %` : '';
};

export const fotosDelAlta = (perfil) => {
    if (!perfil) return [];
    return FOTOS.map(({ clave, titulo, campoId, campoViejo }) => {
        const detalle = clave === 'mejor_forma' ? detalleMejorForma(perfil) : detalleGrasa(perfil);
        const id = perfil[campoId];
        if (id && typeof id === 'string') return { clave, titulo, detalle, id };
        if (esImagenEnBase64(perfil[campoViejo])) return { clave, titulo, detalle, dataUrl: perfil[campoViejo] };
        return null;
    }).filter(Boolean);
};
